<div class="input-control-wrapper {{classess}}" [class.light-mode]="lightMode">
  <div class="inline-label-text-control">
    @if (flagPrefix) {
    <div class="flag-block">
      <div class="flag-inner">
        <img src="./../../../../assets/images/icons/navigation/is-flag.svg" alt="is-flag">
        <p>IS</p>
      </div>
    </div>
    }
    @if (label) {
    <label [class.disabled]="disabled" htmlFor="{{name}}">{{label}}</label>
    }
    @if (type ==='text' || type === 'email' || type === 'number') {
    <input [class.disabled]="disabled" [pattern]="pattern" [maxlength]="maxlength" [type]="type"
      placeholder="{{placeholder}}" [formControl]="control" pInputText [id]="name" />
    }

    @if (requiredLabelEnabled || optionalLabelEnabled) {
    @if (requiredLabelEnabled) {
    <span class="suffix-label">Required</span>
    }
    @if (optionalLabelEnabled && !control.value) {
    <span class="suffix-label">Optional</span>
    }
    @if (showKenitalaValidation) {
    <span class="suffix-label">&nbsp;({{(control.value?.length || 0)+'/'+maxlength}})</span>
    }
    }


    @if (showKenitalaValidation) {
    @if (maxlength && maxlength == control.value?.length) {
    <div class="suffix-icons">
      <img src="./../../../../../assets/images/icons/form/check_circle.svg" alt="check">
    </div>
    }
    }

    @if (sendMessageIconSuffix) {
    <div pRipple class="suffix-icons">
      <img class="clickable-action" src="./../../../../../assets/images/dialogs/chat/send.svg" alt="send">
    </div>
    }


    @if (type === 'password') {
    <p-password [formControl]="control" [placeholder]="placeholder" [feedback]="false"
      [toggleMask]="editControlAction ? false : true" [inputId]="name">
      <ng-template pTemplate="header">
        <h6 style="margin-bottom:8px;">Password strength</h6>
      </ng-template>
      <!--
        <ng-template pTemplate="footer">
          <p-divider></p-divider>
          <p class="mt-2">Suggestions</p>
          <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
            <li>At least one lowercase</li>
            <li>At least one uppercase</li>
            <li>At least one numeric</li>
            <li>Minimum 8 characters</li>
          </ul>
        </ng-template>                            -->
    </p-password>
    }

    @if (editControlAction) {
    <div pRipple class="suffix-icons" (click)="triggerEditAction()">
      <img class="clickable-action" src="./../../../../../assets/images/icons/edit.svg" alt="edit-password">
    </div>
    }

  </div>

  <app-validation-errors [control]="control" [showKenitalaValidation]="showKenitalaValidation" [maxlength]="maxlength">
  </app-validation-errors>
</div>
